/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';

export const EditIcon = (props: IconTypeProps) => {
  const {
    className,
    id,
    onClick,
    color: colorFromProps,
    size: sizeFromProps,
    style: styleFromProps,
  } = props;
  const color = colorFromProps || '#fff';
  const size = sizeFromProps || 24;

  const style = {
    ...styleFromProps,
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <svg
      id={id}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        d="M6.03984 17.6251C6.08672 17.6251 6.13359 17.6204 6.18047 17.6134L10.1227 16.922C10.1695 16.9126 10.2141 16.8915 10.2469 16.8564L20.182 6.92122C20.2038 6.89953 20.221 6.87378 20.2328 6.84542C20.2445 6.81707 20.2506 6.78668 20.2506 6.75598C20.2506 6.72529 20.2445 6.69489 20.2328 6.66654C20.221 6.63818 20.2038 6.61243 20.182 6.59075L16.2867 2.69309C16.2422 2.64856 16.1836 2.62512 16.1203 2.62512C16.057 2.62512 15.9984 2.64856 15.9539 2.69309L6.01875 12.6282C5.98359 12.6634 5.9625 12.7056 5.95312 12.7525L5.26172 16.6947C5.23892 16.8202 5.24707 16.9494 5.28545 17.0711C5.32384 17.1928 5.39132 17.3033 5.48203 17.3931C5.63672 17.5431 5.83125 17.6251 6.03984 17.6251V17.6251ZM7.61953 13.5376L16.1203 5.03918L17.8383 6.75715L9.3375 15.2556L7.25391 15.6236L7.61953 13.5376V13.5376ZM20.625 19.5939H3.375C2.96016 19.5939 2.625 19.929 2.625 20.3439V21.1876C2.625 21.2907 2.70937 21.3751 2.8125 21.3751H21.1875C21.2906 21.3751 21.375 21.2907 21.375 21.1876V20.3439C21.375 19.929 21.0398 19.5939 20.625 19.5939Z"
        fill={color}
      />
    </svg>
  );
};
